import React, { PropsWithChildren } from "react";
import { Badge } from "react-bootstrap";

interface Props {
  className?: string;
}

export const Pill: React.FC<PropsWithChildren<Props>> = ({ children, className }) => (
  <>
    <Badge pill variant="light" className={`eq-pills ${className ?? ""}`}>
      {children}
    </Badge>
    <style jsx>{`
      :global(.eq-pills) {
        background: #cdcdcd;
        font-weight: 400;
      }
      :global(.eq-pills a) {
        color: #000;
      }
    `}</style>
  </>
)
